module.exports = __webpack_public_path__ + "static/media/W_Calendar_05.2a65ac2d.png";